import { render, staticRenderFns } from "./Spread.vue?vue&type=template&id=cfd8c926&scoped=true&"
import script from "./Spread.vue?vue&type=script&lang=js&"
export * from "./Spread.vue?vue&type=script&lang=js&"
import style0 from "./Spread.vue?vue&type=style&index=0&id=cfd8c926&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd8c926",
  null
  
)

export default component.exports